const getFileTypeFromMime = (mime: string) =>
  mime.split('/')?.[1]?.toUpperCase() || '';

export default getFileTypeFromMime;
